import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

// eslint-disable-next-line no-unused-vars
const URL = process.env.VUE_APP_API_URL

class DocumentoServico extends Servico {
  constructor() {
    super('documentos')
  }

  enviarDocumento(data) {
    store.setCarregando()
    return axios
      .post(`${URL}/documentos`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
}

export default DocumentoServico
